export const beneficiaryToDto = (data = {}) => ({
  document_type: data.documentType,
  document_number: data.documentNumber,
  first_name: data.firstName,
  last_name: data.lastName,
  birthday_date: data.dateOfBirth,
  gender: data.gender,
  phone_number: data.phoneNumber,
  email: data.email,
})

export const beneficiaryFromDto = (dataDto = {}) => ({
  documentType: dataDto.document_type,
  documentNumber: dataDto.document_number,
  firstName: dataDto.first_name,
  lastName: dataDto.last_name,
  dateOfBirth: dataDto.birthday_date,
  gender: dataDto.gender,
  phoneNumber: dataDto.phone_number,
  email: dataDto.email,
})

export const quotationToDto = (data = {}) => {
  const { beneficiary, isBeneficiarySameAsTaker, ...rest } = data

  return {
    ...rest, // Evita pérdida de campos no mapeados
    beneficiary_same_as_client: isBeneficiarySameAsTaker,
    beneficiary: beneficiaryToDto(beneficiary),
  }
}

export const quotationFromDto = (dataDto = {}) => {
  const { beneficiary_same_as_client, beneficiary, ...rest } = dataDto;

  return {
    ...rest, // Evita pérdida de campos no mapeados
    isBeneficiarySameAsTaker: beneficiary_same_as_client,
    beneficiary: beneficiaryFromDto(beneficiary),
  };
};
